var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#C4DFE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.5C24.55 30.5 25 30.95 25 31.5C25 32.05 24.55 32.5 24 32.5C23.45 32.5 23 32.05 23 31.5C23 30.95 23.45 30.5 24 30.5Z",
    fill: "#002340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 33C31 34.655 29.655 36 28 36H20C18.345 36 17 34.655 17 33V15C17 13.345 18.345 12 20 12H28C29.655 12 31 13.345 31 15V33ZM29 15V33C29 33.55 28.55 34 28 34H20C19.45 34 19 33.55 19 33V15C19 14.45 19.45 14 20 14H28C28.55 14 29 14.45 29 15Z",
    fill: "#002340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone_2.36706d73deb7266fc377f7bd0e748db7.svg";
export { ForwardRef as ReactComponent };